import { getLocale } from '@umijs/max';
import { isVietnameseLocale } from './locale';

export enum AuthAction {
  REDIRECT_LOGIN = 'REDIRECT_LOGIN',
  SHOW_ERROR = 'SHOW_ERROR',
  NONE = 'NONE',
}

export type AuthErrorResult = {
  action: AuthAction;
  message?: string;
};

function localized(en: string, vi: string): string {
  return isVietnameseLocale(getLocale?.()) ? vi : en;
}

export function classifyAuthError(error: any): AuthErrorResult {
  const status = error?.response?.status;
  if (!status) return { action: AuthAction.NONE };

  if (status === 401) {
    const url = error?.response?.config?.url ?? '';
    if (url.includes('/authenticate') || url.includes('/public/')) {
      return { action: AuthAction.SHOW_ERROR };
    }
    return {
      action: AuthAction.REDIRECT_LOGIN,
      message: localized(
        'Session expired. Please sign in again.',
        'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
      ),
    };
  }

  if (status === 403) {
    return { action: AuthAction.SHOW_ERROR };
  }

  return { action: AuthAction.NONE };
}
